import React, { useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import { FiPlus, FiTrash2 } from "react-icons/fi";

function PackageManagement() {
  const [packages, setPackages] = useState([
    {
      id: 1,
      name: "Starter Pack",
      items: [{ id: 101, name: "Mobile Phone", price: 499, quantity: 1 }],
    },
    { id: 2, name: "Fashion Bundle", items: [] },
  ]);

  const [newPackage, setNewPackage] = useState("");
  const [newItem, setNewItem] = useState({});

  // Add Package
  const addPackage = () => {
    if (!newPackage.trim()) return;
    setPackages([
      ...packages,
      { id: Date.now(), name: newPackage.trim(), items: [] },
    ]);
    setNewPackage("");
  };

  // Delete Package
  const deletePackage = (id) => {
    setPackages(packages.filter((p) => p.id !== id));
  };

  // Add Item to Package
  const addItem = (pkgId) => {
    const itemName = newItem[pkgId]?.name;
    const itemPrice = parseFloat(newItem[pkgId]?.price || 0);
    const itemQty = parseInt(newItem[pkgId]?.quantity || 1);

    if (!itemName || !itemName.trim()) return;

    setPackages(
      packages.map((p) =>
        p.id === pkgId
          ? {
              ...p,
              items: [
                ...p.items,
                { id: Date.now(), name: itemName.trim(), price: itemPrice, quantity: itemQty },
              ],
            }
          : p
      )
    );
    setNewItem({ ...newItem, [pkgId]: {} });
  };

  // Delete Item
  const deleteItem = (pkgId, itemId) => {
    setPackages(
      packages.map((p) =>
        p.id === pkgId
          ? { ...p, items: p.items.filter((i) => i.id !== itemId) }
          : p
      )
    );
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content p-4">
          <h4 className="breadcrumb-title mb-4">Package Management</h4>

          <div className="row">
            <div className="col-md-8 border card p-4">
              {/* Add New Package */}
              <div className="row mb-4">
                <div className="col-md-8">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="New package name"
                    value={newPackage}
                    onChange={(e) => setNewPackage(e.target.value)}
                  />
                </div>
                <div className="col-md-4">
                  <button className="btn btn-primary w-100" onClick={addPackage}>
                    <FiPlus /> Add Package
                  </button>
                </div>
              </div>

              {/* Package List */}
              <div className="package-list">
                {packages.map((pkg) => (
                  <div key={pkg.id} className="row mb-3 package-card p-3 rounded shadow-sm">
                    {/* Package Name */}
                    <div className="col-12 d-flex justify-content-between align-items-center mb-2">
                      <h5 className="mb-0">{pkg.name}</h5>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => deletePackage(pkg.id)}
                      >
                        <FiTrash2 />
                      </button>
                    </div>

                    {/* Items */}
                    <div className="col-12 item-container mt-2">
                      {pkg.items.length > 0 ? (
                        pkg.items.map((item) => (
                          <div key={item.id} className="row align-items-center mb-1 item-row">
                            <div className="col-5">{item.name}</div>
                            <div className="col-3">₹{item.price}</div>
                            <div className="col-2">Qty: {item.quantity}</div>
                            <div className="col-2 text-end">
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => deleteItem(pkg.id, item.id)}
                              >
                                <FiTrash2 />
                              </button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-muted ms-3">No items in this package</p>
                      )}

                      {/* Add Item */}
                      <div className="row mt-2">
                        <div className="col-4">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Item name"
                            value={newItem[pkg.id]?.name || ""}
                            onChange={(e) =>
                              setNewItem({
                                ...newItem,
                                [pkg.id]: { ...newItem[pkg.id], name: e.target.value },
                              })
                            }
                          />
                        </div>
                        <div className="col-3">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Price"
                            value={newItem[pkg.id]?.price || ""}
                            onChange={(e) =>
                              setNewItem({
                                ...newItem,
                                [pkg.id]: { ...newItem[pkg.id], price: e.target.value },
                              })
                            }
                          />
                        </div>
                        <div className="col-2">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Qty"
                            value={newItem[pkg.id]?.quantity || ""}
                            onChange={(e) =>
                              setNewItem({
                                ...newItem,
                                [pkg.id]: { ...newItem[pkg.id], quantity: e.target.value },
                              })
                            }
                          />
                        </div>
                        <div className="col-3">
                          <button
                            className="btn btn-secondary w-100"
                            onClick={() => addItem(pkg.id)}
                          >
                            <FiPlus /> Add Item
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-md-4">
              {/* Can use this for package summary / statistics */}
            </div>
          </div>
        </div>
      </main>

      <style>
        {`
          .package-card {
            border-left: 4px solid #0d6efd;
            background: #fff;
            transition: box-shadow 0.2s;
          }
          .package-card:hover {
            box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          }
          .item-container {
            margin-left: 15px;
            padding-left: 15px;
            border-left: 2px solid #dee2e6;
          }
          .item-row::before {
            content: '';
            position: absolute;
            top: 50%;
            left: -10px;
            width: 10px;
            height: 2px;
            background-color: #dee2e6;
          }
        `}
      </style>
    </>
  );
}

export default PackageManagement;
